<template>
	<div class="app-info">
		<div class="app-info__label">{{ label }}</div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: ['label']
}
</script>

<style lang="scss" scoped>
.app-info {
	display: inline-block;
	font-size: 1em;

	&__label {
		font-weight: bold;
		margin-bottom: .5em;
	}
}
</style>
